import get from 'lodash/get';

const getEnabledRelations = (document, relationKey) =>
  (get(document, relationKey) || []).filter(
    (relationDoc) => relationDoc.options && relationDoc.options.enabled
  );

export default getEnabledRelations;
